import React from 'react';

import { SVGProps } from './SVGProps';

const MinusIcon = ({ fill = 'none', width = '24', height = '25', stroke = 'black' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 12.5725H19" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default MinusIcon;
